<template>
  <div class="baseball-global-game-params-root">
    <div class="baseball-global-game-params-content">
      <div
        v-if="gameParams"
        class="global-params-header"
      >
        <div class="global-param-header-single">
          <div class="global-param-header-title">
            Start RHO (Air density)
          </div>
          <div class="global-param-header-content">
            <GameParamNumberInput
              :param="rhoStart"
              :parent-selector="parentSelector"
              @paramChange="onGlobalParamChange"
              @paramIncrease="onGlobalParamIncrease"
              @paramDecrease="onGlobalParamDecrease"
            />
            <GameParamNumberInput
              :param="rhoStartManual"
              :parent-selector="parentSelector"
              @paramChange="onGlobalParamChange"
              @paramIncrease="onGlobalParamIncrease"
              @paramDecrease="onGlobalParamDecrease"
            />
          </div>
        </div>
        <div class="global-param-header-single">
          <div class="global-param-header-title">
            End RHO (Air density)
          </div>
          <div class="global-param-header-content">
            <GameParamNumberInput
              :param="rhoEnd"
              :parent-selector="parentSelector"
              @paramChange="onGlobalParamChange"
              @paramIncrease="onGlobalParamIncrease"
              @paramDecrease="onGlobalParamDecrease"
            />
            <GameParamNumberInput
              :param="rhoEndManual"
              :parent-selector="parentSelector"
              @paramChange="onGlobalParamChange"
              @paramIncrease="onGlobalParamIncrease"
              @paramDecrease="onGlobalParamDecrease"
            />
          </div>
        </div>
        <div class="global-param-header-single">
          <div class="global-param-header-title">
            Home run rate
          </div>
          <div class="global-param-header-content">
            <GameParamNumberInput
              :param="homeRunRate"
              @paramChange="onGlobalParamChange"
              @paramIncrease="onGlobalParamIncrease"
              @paramDecrease="onGlobalParamDecrease"
            />
            <div class="global-param-header-toggle">
              <Toggle
                :model-value="useHomeRunRate.value"

                @update:model-value="value => { onGlobalParamChange(value, useHomeRunRate) }"
              />
              <span>{{ useHomeRunRate.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import GameParamNumberInput from '@/components/player-setup/common/GameParamNumberInput';
import Toggle from '@/components/common/Toggle';

export default {
  components: {
    GameParamNumberInput,
    Toggle,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    parentSelector: {
      type: String,
      default: null,
    },
  },
  emits: ['paramChange', 'paramIncrease', 'paramDecrease'],
  setup(props, { emit }) {
    const gameParams = computed(() => props?.event?.params?.gameParams);
    const rhoStart = computed(() => gameParams.value?.weatherData?.rhoStart);
    const rhoStartManual = computed(() => gameParams.value?.weatherData?.rhoStartManual);
    const rhoEnd = computed(() => gameParams.value?.weatherData?.rhoEnd);
    const rhoEndManual = computed(() => gameParams.value?.weatherData?.rhoEndManual);
    const homeRunRate = computed(() => gameParams.value?.homeRunRate);
    const useHomeRunRate = computed(() => gameParams.value?.useHomeRunRate);
    const onGlobalParamChange = (value, param) => {
      emit('paramChange', value, param);
    };
    const onGlobalParamIncrease = (param) => {
      debugger;
      emit('paramIncrease', param);
    };
    const onGlobalParamDecrease = (param) => {
      debugger;
      emit('paramDecrease', param);
    };
    return {
      gameParams,
      rhoStart,
      rhoStartManual,
      rhoEnd,
      rhoEndManual,
      homeRunRate,
      useHomeRunRate,
      onGlobalParamChange,
      onGlobalParamIncrease,
      onGlobalParamDecrease,
    };
  },
};
</script>

<style lang="scss">
.baseball-global-game-params-root {
  height: 100%;
  padding: 0;
  .baseball-global-game-params-content {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .global-params-header {
      height: 100px;
      width: 100%;
      align-items: center;
      gap: 16px;
      padding-bottom: 16px;
      .global-param-header-single {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        .global-param-header-title {
          font-size: 12px;
          font-weight: 600;
          line-height: 14px;
        }
        .global-param-header-content {
          display: flex;
          align-items: flex-end;
          gap: 8px;
          .park-id-dropdown-root {
            .park-id-label {
              display: inline-block;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #6D6D6D;
              text-transform: uppercase;
              font-size: 10px;
              line-height: 12px;
              font-weight: 600;
            }
            .park-id-dropdown {
              display: flex;
              flex-direction: column;
              .dropdown-menu {
                max-height: 300px;
                overflow: auto;
                .dropdown-item {
                  padding: 10px 12px;
                }
              }
            }
          }
          .global-param-header-toggle {
            display: flex;
            align-items: center;
            gap: 4px;
            margin-left: 16px;
          }
        }
      }
      .button {
        margin-left: auto;
        margin-top: auto;
        .icon svg path {
          stroke: $black;
        }
      }
    }
  }
}
</style>
